import cn from 'classnames';
import React, {FC} from 'react';

import ButtonRaw from '../../Button/ButtonRaw';
import {ArrowIcon} from '../../Icons';
import styles from './CarouselArrow.module.scss';
import {CarouselArrowTypes} from './CarouselArrowTypes';

const CarouselArrow: FC<CarouselArrowTypes> = (props) => {
    const {onClick, customClassName, testId, ariaLabel, isVisible, tabIndex} = props;

    if (!isVisible) return null;

    return (
        <ButtonRaw
            ariaLabel={ariaLabel}
            testId={testId}
            onClick={onClick}
            className={cn(styles.Arrow, customClassName)}
            tabIndex={tabIndex}
        >
            <ArrowIcon />
        </ButtonRaw>
    );
};

export default CarouselArrow;
